import React from "react"; // eslint-disable-line no-unused-vars
import { connect } from "react-redux";
import { addNotification as notify } from "reapop";
import { api } from "../index.api";
import { Modal, ModalBody } from "reactstrap";
import { ABBVIE_EMPLOYEE, PATIENT } from "../../constants";
// The business has confirmed that this component is not currently necessary
// import SearchResultModal from '../modals/SearchResultModal'
import DocumentsTableDesktop from "./DocumentsTableDesktop";
import DocumentsTableMobile from "./DocumentsTableMobile";
import StaticConfig from "../StaticConfig";

/**
 * Renders a table of downloadable documents.  Requires a set of columnNames and columnKeys to map the table
 * data to each column.  Table data can come as either an array of documents (Search.js and ProductDocumentSearch.js)
 * or an array of grouped documents (ProductDocumentation.js).  A showMobileVersion prop indicates when to switch
 * the table display to vertical cards.  Download feedback can be enabled via a parameter on handleItemStatusChange
 * and by providing a handleItemFeedback callback.
 */
class DownloadableDocumentsTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      downloading: false,
      downloadPopupModalIsOpen: false,
      downloadPopupIndex: null,
      downloadPopupItembundle: null,
      // content: this.props.pageContent.
    };
  }

  onDownloadButtonClick = (listIndex, itemBundle) => {
    // Navigator.platform is deprecated, but the business has confirmed that this code is not currently necessary
    // if (StaticConfig.Context.UserType === 'ABBVIE_EMPLOYEE' && navigator.platform === 'iPad' && !clickedFromModal) {
    //   this.setState({ showModal: true, itemBundle })
    //   return
    // }

    this.setState({ downloading: true });
    this.props.handleItemStatusChange(itemBundle.parent.id, true);
    var ids = [];
    ids.push(itemBundle.id);
    var childrenItems = itemBundle.childs;
    if (childrenItems) {
      for (let i = 0; i < childrenItems.length; i++) {
        ids.push(childrenItems[i].id);
      }
    }

    this.triggerDownload(listIndex, itemBundle, ids);
  };

  triggerDownload(listIndex, itemBundle, ids) {
    if (!StaticConfig.Context.ComponentConfig.mergeGcFirst) {
      ids = ids.reverse();
    }

    const queryParams = {
      veevaVaultDocIds: ids,
      countryName:
        StaticConfig.Context.UserType === ABBVIE_EMPLOYEE
          ? StaticConfig.Context.ssoCountry.name
          : StaticConfig.Context.Country.name,
      productCode: this.props.searchedProductCode,
      searchAuditId: this.props.searchAuditId,
      parentDocId: itemBundle.parent.id,
      bundleName: itemBundle.parent.bullet_text__c,
      searchUserType: StaticConfig.Context.UserType,
      type: window.location.pathname === "/allergen" ? 'Allergen' : null
    };

    api.bundleDocumentDownload(
      queryParams,
      (response) => {
        if (!response.ok) {
          this.handleDownloadError(itemBundle);
          return;
        }
        const page = window.location.pathname === "/allergen";

        response.blob().then((blob) => {
          if (page) {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.target = "_blank";
            a.rel = "noopener noreferrer";
            document.body.appendChild(a);
            a.click();
            a.remove();
            this.setState({ downloading: false });
            this.props.handleItemStatusChange(
              itemBundle.parent.id,
              false
            );
          } else {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download =
              itemBundle.parent.bullet_text__c + "." + blob.type.split("/")[1];
            document.body.appendChild(a);
            a.click();
            a.remove();
            this.setState({ downloading: false });
            this.props.handleItemStatusChange(
              itemBundle.parent.id,
              false
            );
          }
        });
      },
      () => this.handleDownloadError(itemBundle)
    );
  }

  handleDownloadError = (itemBundle) => {
    const { notify } = this.props;
    notify({
      title: "Error",
      message:
        "There seems to be an error at our server side. Please try again later.",
      status: "error",
      position: "tr",
      dismissible: true,
      dismissAfter: 5000,
    });
    this.setState({ downloading: false });
    this.props.handleItemStatusChange(itemBundle.parent.id, false);
  };

  render() {
    const {
      id,
      items,
      pageContent,
      columnNames,
      columnKeys,
      searchAuditId,
      showMobileVersion,
    } = this.props;
    const rows = items || [];
    const languageContent = pageContent.content.module.searchDocument;
    return (
      <React.Fragment>
        {showMobileVersion ? (
          <DocumentsTableMobile
            id={id}
            languageContent={languageContent}
            isDownloading={this.state.downloading}
            columnNames={columnNames}
            columnKeys={columnKeys}
            rows={rows}
            showDownloadPopupModal={this.showDownloadPopupModal}
            searchAuditId={searchAuditId}
          />
        ) : (
          <DocumentsTableDesktop
            id={id}
            languageContent={languageContent}
            isDownloading={this.state.downloading}
            columnNames={columnNames}
            columnKeys={columnKeys}
            rows={rows}
            showDownloadPopupModal={this.showDownloadPopupModal}
            searchAuditId={searchAuditId}
          />
        )}

        {/* The business has confirmed that this code is not currently necessary */}
        {/* <SearchResultModal
          closeModal={() => this.setState({ showModal: false })}
          showModal={this.state.showModal}
          searchedProductCode={searchedProductCode}
          // countryName={countryName}  // TODO: use StaticConfig instead
          searchAuditId={searchAuditId}
          itemBundle={this.state.itemBundle}
          downloadAll={this.onDownloadButtonClick}
        /> */}

        <div>
          <Modal
            className="download-popup-modal"
            isOpen={this.state.downloadPopupModalIsOpen}
            backdrop
            keyboard={false}
            wrapClassName="modal-primary"
            size="sm"
          >
            {/* This would allow a user to exit the Modal. Not currently in use */}
            {/*<ModalHeader
              toggle={() => this.handleHideDownloadPopupModal()}
            >
            </ModalHeader>*/}
            <ModalBody>
              <div>{languageContent.popUpInfo}</div>
              <div className="download-popup-button">
                <button
                  type="button"
                  onClick={(e) => {
                    this.onDownloadButtonClick(
                      this.state.downloadPopupIndex,
                      this.state.downloadPopupItembundle
                    );
                    this.handleHideDownloadPopupModal();
                  }}
                  className="btn btn-primary submit-button btn-rounded"
                >
                  {languageContent.agree}
                </button>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </React.Fragment>
    );
  }

  showDownloadPopupModal = (index, itemBundle) => {
    this.setState({
      downloadPopupModalIsOpen: true,
      downloadPopupIndex: index,
      downloadPopupItembundle: itemBundle,
    });
  };

  handleHideDownloadPopupModal = () => {
    this.setState({ downloadPopupModalIsOpen: false });
  };
}

function mapStateToProps(state) {
  return {
    pageContent: state.pageContent,
  };
}

export default connect(mapStateToProps, { notify })(DownloadableDocumentsTable);



// WEBPACK FOOTER //
// ./src/mi-app/tables/DownloadableDocumentsTable.js